export const isBrowser = (): boolean => typeof window !== "undefined"
